import { apiClient } from '@/lib/api-client';

export interface JobRow {
  name: string;
  task: string;
  service: 'Product Backend' | 'Notification Backend';
  schedule: string;
  scheduleType: 'interval' | 'cron';
  scheduleValue: string | number;
  description: string;
  status: 'running' | 'idle';
  checkedAt: string;
}

export const jobSchedulerApi = {
  list(): Promise<JobRow[]> {
    return apiClient.get('/admin/jobs');
  },
  trigger(taskName: string): Promise<{ task: string; triggered: boolean }> {
    return apiClient.post(`/admin/jobs/${taskName}/run`);
  },
};
